import Graveyard from './Graveyard';

export default Graveyard;
